import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-navy-950 text-slate-300 text-xs md:text-sm py-2 text-center font-medium px-4" data-id="element-17">
      Para pymes retail con productos reales · Evaluación inicial por WhatsApp
    </div>;
}